import { SetStateAction } from 'react';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type ExpandedStore = {
  expanded: Record<number, boolean>;
  setExpanded: (id: number, expanded: SetStateAction<boolean>) => void;
  getExpanded: (id: number, defaultValue?: boolean) => boolean;
};

export const useExpandedStore = create(
  persist<ExpandedStore>(
    (set, get) => {
      return {
        expanded: {},
        setExpanded: (id: number, expanded: SetStateAction<boolean>) => {
          const prevValue = get().expanded[id] ?? false;
          const newValue = typeof expanded === 'boolean' ? expanded : expanded(prevValue);

          set((state) => {
            return {
              ...state,
              expanded: {
                ...state.expanded,
                [id]: newValue,
              },
            };
          });
        },
        getExpanded: (id: number, defaultValue?: boolean) => get().expanded[id] ?? defaultValue ?? false,
      };
    },
    {
      name: 'expanded-todo-tree-list-store',
    },
  ),
);
